import { StorageLRU, asyncify } from 'storage-lru';

const storageLRU = new StorageLRU(asyncify(localStorage));

function getStoredTemplate() {
  let mobileElementsFromLS = {};
  let desktopElementsFromLS = {};
  const match = window.location.search.match(/template_copy_id=([^&]+)/);
  if (match && match.length === 2) {
    storageLRU.getItem(match[1], {json: true}, (err, item) => {
      if (!err) {
        if (item.desktop) {
          desktopElementsFromLS = item.desktop;
        }
        if (item.mobile) {
          mobileElementsFromLS = item.mobile;
        }
      }
    });
  }
  return {
    desktopElementsFromLS,
    mobileElementsFromLS
  };
}

export {
  getStoredTemplate
};
